import { render, staticRenderFns } from "./textScroll.vue?vue&type=template&id=2b85484d&scoped=true&"
import script from "./textScroll.vue?vue&type=script&lang=js&"
export * from "./textScroll.vue?vue&type=script&lang=js&"
import style0 from "./textScroll.vue?vue&type=style&index=0&id=2b85484d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85484d",
  null
  
)

export default component.exports